import { DateTime } from 'luxon';
import { SubjectData } from 'shell/models/person';
import { Document } from 'front-office/view-models/release-id-card/document';

export const transformDocument = (subjectData: SubjectData): Document => {
  let showParents = false;
  const expatriationBan = subjectData.cittadinanza?.every((c) => c.codiceStato !== '100');
  //subjectData?attributiSoggetto?.senzaFissaDimora === 'S' ||

  if (subjectData.generalita?.dataNascita) {
    const birthDate = DateTime.fromISO(subjectData.generalita?.dataNascita);
    showParents =
      Math.abs(Number.parseInt(birthDate.diffNow('years').years.toString())) < 14 &&
      !expatriationBan;
  }
  const previousCard = subjectData?.cartaIdentita?.numero || '';

  return {
    previousCard,
    number: '',
    hair: '',
    eyes: '',
    stature: '',
    hasPreviousCard: !!previousCard,
    particularSigns: '',
    parentsPrint: '',
    yieldCard: !previousCard ? '0' : '',
    domicile: '',
    releaseMode: '',
    typePayment: '',
    previousMunicipality: subjectData?.cartaIdentita?.comuneRilascio,
    expirationDateOld: subjectData?.cartaIdentita?.dataScadenza
      ? DateTime.fromISO(subjectData?.cartaIdentita?.dataScadenza)
      : null,
    stillValid: getValidity(subjectData?.cartaIdentita?.dataScadenza),
    releaseDate: DateTime.local(),
    expirationDate: getExpirationDate(),
    isExpatriationBan: expatriationBan,
    type: '0',
    showParents,
  };
};

const isLeapYear = (year: number): boolean => {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
};

export const transformExpiryDate = (dataNascita: string): DateTime => {
  const birthDate = DateTime.fromISO(dataNascita);
  const birthMonth = birthDate.get('month');
  const birthDay = birthDate.get('day');
  const birthYear = birthDate.get('year');

  const currentDate = DateTime.now();
  const currentYear = currentDate.get('year');
  const currentMonth = currentDate.get('month');
  const currentDay = currentDate.get('day');

  let age = currentYear - birthYear;
  if (birthMonth > currentMonth || (birthMonth === currentMonth && birthDay > currentDay)) {
    age -= 1;
  }

  let expiryYear;
  if (age < 3) {
    expiryYear = currentYear + 3;
  } else if (age >= 3 && age < 18) {
    expiryYear = currentYear + 5;
  } else {
    expiryYear = currentYear + 9;
  }

  if (birthMonth < currentMonth || (birthMonth === currentMonth && birthDay < currentDay)) {
    expiryYear += 1;
  }

  let expiryDay = birthDay;
  let expiryMonth = birthMonth;

  if (!isLeapYear(expiryYear) && birthDay === 29 && birthMonth === 2) {
    expiryDay = 1;
    expiryMonth = 3;
  } else {
    expiryDay = birthDay;
    expiryMonth = birthMonth;
  }

  const expiryDate = DateTime.fromObject({
    year: expiryYear,
    month: expiryMonth,
    day: expiryDay,
  });

  return expiryDate;
};

export const getExpirationDate = (): DateTime | null => {
  // if (!subjectData?.generalita?.dataNascita) return null;
  // return transformExpiryDate(subjectData.generalita.dataNascita);
  return DateTime.local().plus({ months: 6 });
};

export const getValidity = (date: string | undefined): string => {
  if (!date) {
    return '';
  }
  return DateTime.local() > DateTime.fromISO(date) ? 'CARTA NON VALIDA' : 'ANCORA VALIDA';
};
